// import Link from "next/link";
import { useDispatch } from 'react-redux';
import { Button } from '../ui/button';
import { setPageNotFound } from '@/components/default/redux/slices/uiSlice';

export default function Custom404() {
    const dispactch = useDispatch();
    function goBackHome() {
        dispactch(setPageNotFound(false));
        window.location.href = '/'; // or window.location.replace('/') to replace the current page in the history
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-slate-100 to-slate-200 px-6 py-12">
            <div className="text-center max-w-xl">
                <h1 className="text-[8rem] leading-none font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-600">404</h1>
                <h2 className="text-3xl font-bold text-slate-800 mb-4">Page not found</h2>
                <p className="text-slate-600 mb-6">Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved.</p>

                <Button onClick={goBackHome} className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition">
                    Go back home
                </Button>
            </div>
        </div>
    );
}
